export default __webpack_public_path__ + "static/media/expl-dissect_15_DE.67fac8ef.png";